export var ListCountEstimateMode;
(function (ListCountEstimateMode) {
    ListCountEstimateMode["Exact"] = "Exact";
    ListCountEstimateMode["Estimated"] = "Estimated";
})(ListCountEstimateMode || (ListCountEstimateMode = {}));
//# sourceMappingURL=paginationSummary.js.map